//Scroll to top of the page
$('#footer__top').click(function() {
  $('html, body').animate({ scrollTop: 0 }, 'slow');
  return false;
});



// WEBPACK FOOTER //
// ./src/js/footerScrollTop.js